import {Component, Input} from '@angular/core';
import {BaseModal} from '@ui-app/modals/base-modal';

@Component({
    selector: 'employee-ui-badge-damaged-modal',
    templateUrl: './badge-damaged-modal.component.html',
    styleUrls: ['./badge-damaged-modal.component.less']
})
export class BadgeDamagedModalComponent extends BaseModal {
    @Input() buttonsTitle = {
        close: 'Close'
    };
    text = 'To restore your badge, please reach out to the badging station';

}
